import { useEffect } from "react";

export function useAutoScrollDrag(boardRef, isDragging) {
  useEffect(() => {
    const moveHandler = (e) => {
      if (!isDragging.current) return;
      const board = boardRef.current;
      if (!board) return;

      const clientX = e.touches?.[0]?.clientX ?? e.clientX;
      if (!clientX) return;

      const rect = board.getBoundingClientRect();
      const EDGE = 60;
      const STEP = 16;

      if (clientX > rect.right - EDGE) board.scrollLeft += STEP;
      if (clientX < rect.left + EDGE) board.scrollLeft -= STEP;
    };

    window.addEventListener("mousemove", moveHandler);
    window.addEventListener("touchmove", moveHandler, { passive: true });

    return () => {
      window.removeEventListener("mousemove", moveHandler);
      window.removeEventListener("touchmove", moveHandler);
    };
  }, []);
}
